export const JOB_TYPES_BOOKING = "job-types-booking";